<template>
  <div class="site-shell bs-foundation">
    <a class="skip-link" href="#main">Skip to content</a>
    <DialogRoot v-model:open="sidebarOpen">
      <nav aria-label="Compact navigation" class="site-compact" :style="brandBackground">
        <div class="site-container bs:flex bs:items-center">
          <DialogTrigger as-child><button class="site-menu-button site-menu-toggle" aria-label="Open navigation" :aria-expanded="sidebarOpen" :style="brandForeground"><IconMenu2 class="bs-icon" :size="20" :stroke="2" aria-hidden="true" focusable="false" /></button></DialogTrigger>
          <a class="mobile-brand" href="/"><img :src="branding && branding.image ? branding.image : '/dist/static/brew-status-logo-black.svg'" :alt="branding && branding.image ? branding.name + ' Logo' : 'Brew Status'"></a>
          <a v-if="!user && !authPage" class="mobile-login" href="/login" :style="brandForeground">Log in</a>
        </div>
      </nav>
      <DialogPortal>
        <DialogOverlay class="site-menu-backdrop" />
        <DialogContent class="site-drawer bs-foundation" :aria-describedby="undefined">
          <DialogTitle class="bs:sr-only">Navigation</DialogTitle>
          <nav aria-label="Mobile navigation">
            <a class="site-drawer-brand" href="/"><img src="/dist/static/brew-status-logo-white.svg" alt="Brew Status"></a>
            <template v-if="user">
              <a v-for="link in links" :key="link[0]" :href="link[0]">{{ link[1] }}</a>
              <template v-if="user.isAdmin"><div class="site-drawer-group">Admin Links</div><a v-for="link in adminLinks" :key="link[0]" :href="link[0]">{{ link[1] }}</a></template>
              <button class="site-menu-button" @click="logout">Log off</button>
            </template>
            <template v-else><a href="/register"><b>Sign up</b></a><a href="/login"><b>Log in</b></a></template>
            <DialogClose as-child><button class="site-menu-button">Close menu</button></DialogClose>
          </nav>
        </DialogContent>
      </DialogPortal>
    </DialogRoot>
    <div class="pusher" data-site-content>
      <div class="full height">
        <nav aria-label="Main navigation" class="site-navigation" :style="brandBackground">
          <div class="site-container site-nav-row">
            <template v-if="branding">
              <img v-if="branding.image" class="site-brewery-logo" :src="branding.image" :alt="branding.name + ' Logo'">
              <div class="site-name"><a href="/" :style="brandForeground">{{ branding.name }}</a><div class="site-powered" :style="brandForeground">Powered by <a href="/" :style="brandForeground">BrewStat.us</a></div></div>
            </template>
            <a v-else class="site-brand" href="/"><img src="/dist/static/brew-status-logo-black.svg" alt="Brew Status"></a>
            <div class="site-account">
              <details v-if="user" class="user-menu" @keydown.esc="closeAccountMenu">
                <summary :aria-label="'Account menu for ' + user.username"><img v-if="user.avatarUrl" class="site-avatar" :src="user.avatarUrl" alt="avatar"><IconUserCircle v-else class="bs-icon" :size="28" :stroke="2" aria-hidden="true" focusable="false" /></summary>
                <div class="site-account-links">
                  <div class="site-account-heading">{{ user.username }}</div>
                  <a v-for="link in links" :key="link[0]" :href="link[0]">{{ link[1] }}</a>
                  <template v-if="user.isAdmin"><div class="site-account-heading">Admin Links</div><a v-for="link in adminLinks" :key="link[0]" :href="link[0]">{{ link[1] }}</a></template>
                  <button class="site-menu-button" @click="logout">Log off</button>
                </div>
              </details>
              <template v-else-if="!authPage"><a href="/login" class="bs-button">Log in</a><a href="/register" class="bs-button site-signup">Sign up</a></template>
            </div>
          </div>
        </nav>
        <main id="main" tabindex="-1" class="vue-app page site-page"><slot /></main>
      </div>
      <footer class="site-footer">
        <div class="site-container site-footer-grid">
          <section><h2 class="footer-heading">Home</h2><nav aria-label="Footer home" class="site-footer-links">
            <a href="https://github.com/rlightner/public-BrewStatus/issues" target="_blank" rel="noopener">Submit an Issue</a>
            <a href="https://gitter.im/BrewStatus/Lobby" target="_blank" rel="noopener">Join our Chat</a>
            <a v-for="link in footerLinks" :key="link[0]" :href="link[0]">{{ link[1] }}</a>
          </nav></section>
          <section v-if="!authPage"><h2 class="footer-heading">Tools</h2><nav aria-label="Footer tools" class="site-footer-links"><a href="/styles">Styles</a></nav></section>
          <div class="site-copyright">&copy;2016 - {{ year }} BrewStat.us</div>
        </div>
      </footer>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { DialogRoot, DialogTrigger, DialogPortal, DialogOverlay, DialogContent, DialogTitle, DialogClose } from 'reka-ui';
import { IconMenu2, IconUserCircle } from '@tabler/icons-vue';
export default {
  components: { DialogRoot, DialogTrigger, DialogPortal, DialogOverlay, DialogContent, DialogTitle, DialogClose, IconMenu2, IconUserCircle },
  props: { user: { default: null }, branding: { default: null }, authPage: { type: Boolean, default: false } },
  data() { return {
    sidebarOpen: false, year: new Date().getFullYear(),
    links: [['/dashboard', 'Dashboard'], ['/settings/profile', 'Profile'], ['/settings/password', 'Password'], ['/settings/tilt', 'Tilt™ hydrometers'], ['/settings/notifications', 'Alerts'], ['/settings/sharing', 'Share page'], ['/styles', 'Brew Styles'], ['/settings/plans', 'Plan'], ['/settings/billing', 'Billing']],
    adminLinks: [['/admin', 'User Admin'], ['/elmah.axd', 'Elmah'], ['/hangfire', 'Hangfire']],
    footerLinks: [['/privacy-policy', 'Privacy Policy'], ['/terms', 'Terms of Use'], ['/cookiepolicy', 'Cookie Policy'], ['/contact', 'Contact']]
  }; },
  computed: {
    brandBackground() { return this.branding ? { backgroundColor: this.branding.background, color: this.branding.foreground } : null; },
    brandForeground() { return this.branding ? { color: this.branding.foreground } : null; }
  },
  methods: {
    closeAccountMenu(event) { event.currentTarget.open = false; event.currentTarget.querySelector('summary').focus(); },
    async logout() {
      try {
        const token = (await axios.get('/application/auth/token')).data.token;
        const body = new URLSearchParams(); body.append('__RequestVerificationToken', token);
        await axios.post('/application/auth/logout', body); location.assign('/');
      } catch (_) { alert('Unable to log out. Reload and try again.'); }
    }
  }
};
</script>
<style scoped>
/* The shell owns the hosted root rhythm even with Semantic's reset blocked. */
:global(html) { font-size: 14px; }
:global(body) { margin: 0; }
.site-shell { line-height: 1.4285; }
.pusher { display: flex; flex-direction: column; min-height: 100vh; background: var(--bs-color-page); }
.full.height { display: flow-root; flex: 1 0 auto; }
.site-container { width: auto; margin: 0 1rem; }
@media (min-width: 768px) { .site-container { width: 723px; margin-left: auto; margin-right: auto; } }
@media (min-width: 992px) { .site-container { width: 933px; } }
@media (min-width: 1200px) { .site-container { width: 1127px; } }
.site-page { margin-top: 105px; min-height: 550px; padding: 0 0 .5rem; }
.site-page:focus { outline: none; }
.site-navigation { position: fixed; inset: 0 0 auto; z-index: 1900; padding: 1rem 0; background: var(--bs-color-amber-tap); border-top: 7px solid rgba(0,0,0,.18); border-bottom: 1px solid rgba(34,36,38,.15); box-shadow: 0 1px rgba(0,0,0,.1); }
.site-nav-row { display: flex; align-items: center; gap: 1rem; min-height: 44px; }
.site-brand { display: inline-flex; align-items: center; min-height: 44px; padding: 0 1rem; }
.site-brand img { display: block; height: 30px; width: auto; }
.site-account { margin-left: auto; display: flex; align-items: center; gap: 2rem; padding: 0 1rem; }
#app .site-signup { background: var(--bs-color-ink); color: var(--bs-color-surface); }
#app .site-signup:hover { background: var(--bs-color-cap-charcoal); }
.site-brewery-logo { max-width: 65px; max-height: 50px; }
.site-name { font-size: 1.3rem; font-weight: 700; min-width: 0; overflow-wrap: anywhere; }
.site-powered { font-size: 11px; font-weight: 400; }
.site-navigation a { color: var(--bs-color-ink); text-decoration: none; }
.site-navigation :focus-visible, .site-compact :focus-visible { outline-color: currentColor; }
.site-footer :focus-visible { outline-color: var(--bs-color-ink); }
.user-menu { position: relative; }
.user-menu summary { display: flex; align-items: center; justify-content: center; min-width: 44px; min-height: 44px; cursor: pointer; list-style: none; }
.user-menu summary::-webkit-details-marker { display: none; }
.site-avatar { width: 28px; height: 28px; border-radius: 50%; }
.site-account-links { position: absolute; right: 0; top: 100%; min-width: 200px; background: var(--bs-color-surface); border-radius: var(--bs-radius-sm); box-shadow: var(--bs-shadow-card); padding: .5rem 0; }
.site-account-links > a, .site-account-links > button { display: flex; align-items: center; width: 100%; min-height: 44px; padding: .5rem 1rem; color: var(--bs-color-ink); }
.site-account-links > a:hover, .site-account-links > button:hover { background: var(--bs-color-page); }
.site-account-heading { padding: .75rem 1rem; font-weight: 700; border-bottom: 1px solid var(--bs-color-rule); }
.site-menu-button { box-sizing: border-box; margin: 0; border: 0; background: none; font: inherit; cursor: pointer; text-align: left; }
.site-compact { display: none; position: fixed; inset: 0 0 auto; z-index: 1900; background: var(--bs-color-amber-ember); box-shadow: 0 1px rgba(0,0,0,.15); }
.site-menu-toggle { display: flex; align-items: center; justify-content: center; width: 44px; height: 48px; color: var(--bs-color-ink); }
.mobile-brand { display: inline-flex; align-items: center; min-height: 44px; }
.mobile-brand img { height: 24px; max-width: 160px; }
.mobile-login { display: flex; align-items: center; min-height: 44px; margin-left: auto; font-weight: 700; color: var(--bs-color-ink); }
.site-menu-backdrop { position: fixed; inset: 0; background: rgba(0,0,0,.4); z-index: 2000; }
.site-drawer { position: fixed; inset: 0 auto 0 0; z-index: 2001; width: min(250px, 100vw); overflow-y: auto; background: var(--bs-color-ink); color: var(--bs-color-surface); }
.site-drawer a, .site-drawer button, .site-drawer-group { display: flex; align-items: center; min-height: 44px; width: 100%; padding: .8rem 1rem; color: inherit; text-decoration: none; border-bottom: 1px solid rgba(255,255,255,.08); }
.site-drawer a:hover, .site-drawer button:hover { background: rgba(255,255,255,.08); }
.site-drawer :focus-visible { outline: 2px solid var(--bs-color-surface); outline-offset: -3px; }
.site-drawer-brand img { height: 20px; width: auto; }
.site-drawer-group { font-weight: 700; }
.site-footer { flex-shrink: 0; margin: 0; padding: 4rem 0; background: #faad63; color: var(--bs-color-ink); }
.site-footer-grid { display: grid; grid-template-columns: 3fr 3fr 10fr; gap: 2rem; }
.footer-heading { font-size: 1.07142857rem; line-height: 1.2857; margin: 0 0 1rem; padding-bottom: .2rem; border-bottom: 1px solid rgba(34,36,38,.15); }
.site-footer-links { display: flex; flex-direction: column; align-items: flex-start; }
.site-footer-links a { color: inherit; padding: .2rem 0; text-decoration: none; }
.site-footer-links a:hover { text-decoration: underline; }
.site-copyright { grid-column: 1 / -1; text-align: center; }
.skip-link { position: absolute; left: 8px; top: -100px; z-index: 3000; padding: .75rem 1rem; background: var(--bs-color-ink); color: var(--bs-color-surface); border-radius: var(--bs-radius-sm); font-weight: 700; }
.skip-link:focus { top: 8px; color: var(--bs-color-surface); outline: 2px solid var(--bs-color-ink); outline-offset: 2px; }
@media (max-width: 767px) { .site-footer-grid { grid-template-columns: 1fr; } .site-footer-links a { min-height: 44px; display: flex; align-items: center; } }
@media (max-width: 650px) { .site-navigation { display: none; } .site-compact { display: block; } .site-page { margin-top: 55px; min-height: 350px; } }
</style>
